/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./websocket.vue?vue&type=template&id=c2b3873a&scoped=true&"
import script from "./websocket.vue?vue&type=script&lang=js&"
export * from "./websocket.vue?vue&type=script&lang=js&"
import style0 from "./websocket.vue?vue&type=style&index=0&id=c2b3873a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b3873a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
